import {ErrorParser, PageHeader} from "../../../components/exports";
import {useNavigate, useParams} from "react-router-dom";
import {Button, ButtonGroup, Card, Container, Stack, TextField, Typography} from "@mui/material";
import {ChangeEvent, useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "../../../hooks/reduxHooks";
import {
    changeAddress,
    changeIdentificationNumber,
    changeIsCompany,
    changeMobileNumber, changeName, changePostalCode,
    changeTell, setStoreState
} from "../silce/StoreSlice";
import {AccountService} from "../../../api/psc";
import {ErrorDetailContainer} from "../../../api/config";

export enum InvoiceInformationType {
    Personal = "Personal",
    Company = "Company",
}

const pageTitle = {
    form: 'مشخصات کاربر',
    list: 'لیست تغییرات',
}

export default function AccountData() {
    const navigate = useNavigate();
    const storeState = useAppSelector(state => state.storeSlice);
    const dispatch = useAppDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState<ErrorDetailContainer | null>(null);

    useEffect(() => {
        fetchInfo().then();
    }, []);

    const handleIdChange = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch(changeIdentificationNumber(e.target.value))
    }
    const handleAddressChange = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch(changeAddress(e.target.value))
    }
    const handleMobileNumberChange = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch(changeMobileNumber(e.target.value))
    }
    const handleTellChange = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch(changeTell(e.target.value))
    }
    const handlePostalCodeChange = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch(changePostalCode(e.target.value))
    }
    const handleNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch(changeName(e.target.value))
    }

    const handleChangeInvoiceInformationType = (invoiceInformationType: InvoiceInformationType) => {
        dispatch(changeIsCompany(invoiceInformationType === InvoiceInformationType.Company));
    }

    const fetchInfo = async () => {
        try {
            setIsSubmitting(true);
            const info = await AccountService.getInvoiceInformation('1');
            dispatch(setStoreState(info));
        } catch (e) {
        } finally {
            setIsSubmitting(false);
        }
    }

    const handleSubmit = async () => {
        try {
            setIsSubmitting(true);
            await AccountService.setInvoiceInformation('1', storeState);
            navigate('/store')

        } catch (e) {
            setError(e);
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <Container maxWidth="sm">
            <PageHeader
                title={pageTitle.form}
            />

            <Card sx={{flex: 3, p: 2}}>
                <Typography fontSize='medium' sx={{mb: 3}}>
                    لطفا اطلاعات زیر را به دقت وارد کنید، فاکتور رسمی براساس این اطلاعات ساخته خواهد شد.
                </Typography>

                <ButtonGroup sx={{marginBottom: 2}} fullWidth={true}>
                    <Button
                        variant={!storeState.isCompany ? 'contained' : 'outlined'}
                        onClick={() => handleChangeInvoiceInformationType(InvoiceInformationType.Personal)}>
                        حقیقی
                    </Button>
                    <Button
                        variant={storeState.isCompany ? 'contained' : 'outlined'}
                        onClick={() => handleChangeInvoiceInformationType(InvoiceInformationType.Company)}>
                        حقوقی
                    </Button>
                </ButtonGroup>
                <Stack spacing={2} flex={3}>
                    {
                        storeState.isCompany ? (
                            <TextField value={storeState.identificationNumber} onChange={handleIdChange}
                                       label='شناسه ملی / کد اقتصادی'/>
                        ) : (
                            <TextField value={storeState.identificationNumber} onChange={handleIdChange}
                                       label='شماره ملی'/>
                        )
                    }
                    {
                        storeState.isCompany ? (
                            <TextField value={storeState.name} onChange={handleNameChange}
                                       label='نام شرکت'/>
                        ) : (
                            <TextField value={storeState.name} onChange={handleNameChange}
                                       label='نام و نام خانوادگی'/>
                        )
                    }
                    <TextField value={storeState.address} onChange={handleAddressChange} multiline label='آدرس'/>
                    <TextField value={storeState.postalCode} onChange={handlePostalCodeChange} label='کد پستی'/>
                    <TextField value={storeState.tell} onChange={handleTellChange} label='شماره تلفن ثابت'/>
                    <TextField value={storeState.mobileNumber} onChange={handleMobileNumberChange}
                               label='شماره تلفن دارای واتساپ'/>

                    <ErrorParser error={error}/>
                    <Button variant='contained' onClick={handleSubmit} disabled={isSubmitting}>ثبت مشخصات</Button>
                </Stack>
            </Card>
        </Container>
    )
        ;
}
